export default "__VITE_ASSET__Cc$CqMfj__"